import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "view-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "lottery-info" }
const _hoisted_5 = { class: "flag-container" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "lottery-title-row" }
const _hoisted_8 = { class: "lottery-name" }
const _hoisted_9 = { class: "countdown-section" }
const _hoisted_10 = { class: "countdown" }
const _hoisted_11 = { class: "time-block" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "time-block" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "time-block" }
const _hoisted_18 = { class: "time" }
const _hoisted_19 = { class: "label" }

import { getGameLogoUrl } from '../../utils/resultParser';
import { useIntegrationMode } from '@/composables/useIntegrationMode';
import CountryAvatar from '@/components/base/CountryAvatar.vue';


const __default__ = {
  name: "DesktopHeader",
};

interface Lottery {
  game_name?: string;
  game_slug?: string;
  country?: string;
  game_logo?: string;
  draw_date?: string;
  cutoff?: string;
}

interface Props {
  lottery: Lottery | null;
  countdown: {
    hours: number;
    minutes: number;
    seconds: number;
  };
  showWatchLive?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    lottery: {},
    countdown: {},
    showWatchLive: { type: Boolean }
  },
  emits: ["go-back", "watch-live"],
  setup(__props: any) {

const { isLite } = useIntegrationMode();






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-arrow",
        "aria-label": _ctx.$t('common.back'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-back')))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "24",
          height: "24",
          stroke: "currentColor",
          "stroke-width": "3",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
        ], -1)
      ]), 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(isLite))
            ? (_openBlock(), _createBlock(CountryAvatar, {
                key: 0,
                country: _ctx.lottery?.country,
                "fallback-label": _ctx.lottery?.game_name,
                size: "sm"
              }, null, 8, ["country", "fallback-label"]))
            : (_ctx.lottery?.game_logo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo, _ctx.lottery.game_slug),
                  alt: _ctx.lottery.country + ' flag',
                  class: "flag"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.lottery?.game_name || _ctx.$t('common.loading')), 1),
          (_ctx.showWatchLive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "watch-live-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('watch-live')))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", {
                  class: "watch-live-icon",
                  "aria-hidden": "true"
                }, "▶", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('detail.watchLive')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(String(_ctx.countdown.hours).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('time.hours')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(String(_ctx.countdown.minutes).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('time.mins')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(String(_ctx.countdown.seconds).padStart(2, '0')), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('time.secs')), 1)
        ])
      ])
    ])
  ]))
}
}

})